import { connect } from 'react-redux'
import compose from 'lodash/flowRight'

import { RigipsStore } from 'redux/redux'
import { withRouter } from 'react-router-dom'
import withUserDataMutation from './userDataMutation'
import withUserDataQuery from './userDataQuery'

import SettingsUserDataPage from './settingsUserDataPage'

const mapStateToProps = (state: RigipsStore) => {
  const { auth } = state
  const { authenticated } = auth

  return { authenticated }
}

export default compose(
  connect(mapStateToProps),
  withUserDataMutation,
  withUserDataQuery,
)(withRouter(SettingsUserDataPage))
